// base
import { useContext, useEffect, useMemo } from 'react';
import { useHistory } from 'react-router-dom';

// contexts
import { PkgContext } from 'contexts';

// modules
import { LoadingAtom } from 'modules';

// routes
import { ROUTE_CHART_DASHBOARD, ROUTE_MAP_DASHBOARD } from 'routes/const';

// services
import { COOKIE_PKG, cookieStorage } from 'services';

// constants
import { PKG_2 } from 'constants/const';

// libraries
import { useSetRecoilState } from 'recoil';

export const usePkgCheck = () => {
  const context = useContext(PkgContext);

  const setIsLoading = useSetRecoilState(LoadingAtom);

  const history = useHistory();
  const pathname = history.location.pathname;

  const isPkgNo = !!context.pkgNo || cookieStorage.getCookie(COOKIE_PKG);

  const isGsChart = useMemo(() => {
    const isCheck =
      (pathname === ROUTE_CHART_DASHBOARD || pathname === ROUTE_MAP_DASHBOARD) &&
      context.pkgNo === PKG_2;

    return isCheck;
  }, [pathname, context.pkgNo]);

  useEffect(() => {
    if (!isPkgNo) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  }, [setIsLoading, isPkgNo]);

  if (!context) {
    throw new Error('useAlarm must be used within a AlarmProvider');
  }

  return { isPkgNo, isGsChart, ...context };
};
